import config from './config.js'

export default {

  viewparams: {"page":1,"rows":20,"search":"","sort":"map_id","sdir":"desc","cid":""},

  // list orders
  list: function(cb_success) {
    var u = config.baseUrl + 'rest/inventory/list?page=' + this.viewparams.page + '&rows=' + this.viewparams.rows + '&sidx=' + this.viewparams.sort + '&sord=' + this.viewparams.sdir;
    if (this.viewparams.search.length > 0)
      u += '&search=' + encodeURIComponent(this.viewparams.search);
    if (this.viewparams.cid.length > 0)
      u += '&cid=' + this.viewparams.cid;
    fetch(u,{credentials:'include'}).then(resp => resp.json()).then(cb_success);
  }
}
